import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-client-clustering',
  templateUrl: './client-clustering.component.html',
  styleUrls: ['./client-clustering.component.scss']
})
export class ClientClusteringComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
